export default __webpack_public_path__ + "assets/img/avatar-undefined.0caed83.png";